export const MONTH_SCHEDULING_LABELS = {
	daysOfMonthToRunScan: 'Days of month to run scan',
	startTime: 'Start time',
	timezone: 'Timezone',
	startMonth: 'Start Month',
	lastDayOfMonth: 'Last day of month',
	monthlySelectionWarning:
		'If there are less days in a month, the scan will run on the last day of the month.'
};
